<div *ngIf="vm$ | async as vm">
  <div *ngIf="vm.perspectives?.length > 0" class="perspective-row" fxLayout="row" fxLayoutAlign="end center">
  <p class="perspectives-label flex-grow-0 flex-shrink-0 text-sm font-light text-left text-black">
      Perspectives
    </p>
    <mat-form-field class="perspectives-field">
      <mat-select hideSingleSelectionIndicator 
        [matMenuTriggerFor]="perspectives"
        [value]="vm.selected  | translate : locale | async"
        (selectionChange)="selectedPerspectiveChanged($event.value)"
      >
        <mat-option *ngFor="let item of vm.perspectives" [value]="item">
          {{ item.name | translate : locale | async }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
